import React from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Grid, SxProps, Typography } from '@mui/material';
import { EditDrawerFooter } from '../drawers/EditDrawerFooter';
import { attributeDrawerStyles } from './attribute-helper';

interface EditDrawerFooterProps {
    displayFooterError: boolean;
    containerStyles: SxProps;
    onDeleteAttribute: () => void;
    onSubmit: () => void;
}
export const EditDrawerFooterWithError = ({
    onDeleteAttribute,
    onSubmit,
    displayFooterError,
    containerStyles,
}: EditDrawerFooterProps): React.JSX.Element => {
    return (
        <Grid sx={attributeDrawerStyles.drawerFooterWithErrorContainer}>
            {displayFooterError && (
                <Grid sx={attributeDrawerStyles.attributeInUseErrorContainer}>
                    <ErrorOutlineIcon sx={attributeDrawerStyles.errorIcon} />
                    <Typography sx={attributeDrawerStyles.attributeInUseError}>
                        This attribute is part of an index and cannot be renamed
                        or removed.
                    </Typography>
                </Grid>
            )}
            <EditDrawerFooter
                mainContainerStyles={containerStyles}
                onDeleteClick={onDeleteAttribute}
                onSubmitClick={onSubmit}
            />
        </Grid>
    );
};
